import { z } from "zod";

export const serverResponse = z.array(
  z.object({
    id: z.string().optional(),
    value: z.string(),
    msisdnToken: z.string().optional(),
  }),
);
